export default __webpack_public_path__ + "static/media/purpleMarker.4f03e063.svg";